import { Dialog, Toast } from 'vant'
const fn = {
  trim (str) {
    let s = str.replace(/^\s\s*/, '')
    let ws = /\s/
    let i = s.length
    while (ws.test(s.charAt(--i))) {
      return s.slice(0, i + 1)
    }
  },
  empty (obj) {
    if (typeof obj === 'object') {
      return JSON.stringify(obj) === JSON.stringify({})
    }
    if (!obj) {
      return true
    }
    return false
  },
  getDate () {
    let oDate = new Date()
    return {
      year: parseInt(oDate.getFullYear()),
      month: parseInt(oDate.getMonth() + 1),
      day: parseInt(oDate.getDate())
    }
  },
  // 清空对象值
  reset: (obj) => {
    Object.keys(obj).map(key => {
      // Test if it's an Object
      if (obj[key] === Object(obj[key])) {
        this.reset(obj[key])
        return
      }
      if (obj[key] instanceof Array) obj[key] = []
      else obj[key] = undefined
    })
  },
  // 业务错误提示 status=1, http 错误在 http.js 插件中处理
  handleError: (res, type = 'alert', msg = '') => {
    if (!msg) {
      if (typeof res.data.msg !== 'undefined') {
        msg = res.data.msg
      } else if (typeof res.msg !== 'undefined') {
        msg = res.msg
      } else {
        msg = '操作失败！'
      }
    }
    switch (type) {
      case 'alert': Dialog.alert({
        message: msg
      })
        break
      case 'success': Toast.success(msg)
        break
      case 'warning': Toast.fail(msg)
        break
      case 'info': Toast(msg)
        break
      case 'error': Toast.fail(msg)
        break
      default: Dialog.alert({
        message: msg
      })
    }
    return false
  },

  // 将 base64 encode 的图片内容转为文件，方便使用 new FormData() 上传
  dataURLtoFile: (dataurl, filename) => {
    var arr = dataurl.split(','); var mime = arr[0].match(/:(.*?);/)[1]
    var bstr = atob(arr[1]); var n = bstr.length; var u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, { type: mime })
  },

  formatValue (evt) {
    // 只能输入数字 和 ., 只能输入两位小数
    // 前端调用 @keypress="$h.formatValue"
    // let regex = /^\d+(\.\d{0,1})?$/g
    // if (!regex.test(evt.target.value)) {
    //   evt.target.value = evt.target.value.substring(0, evt.target.value.length - 1)
    // }
    evt.target.value = evt.target.value.replace(/[^0-9.]/g, '').replace(/^(\d)+(\.\d{2})(.*)$/g, '$1$2')
    // let charCode = (evt.which) ? evt.which : evt.keyCode
    // if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
    //   evt.preventDefault()
    // } else {
    //   return true
    // }
  } // end of formatValue, 价格保留两位小数
}

export default {
  install (Vue, name = '$h') {
    Object.defineProperty(Vue.prototype, name, { value: fn })
  }
}

export const helper = fn
